import { ExtendedPriceTypeData } from '../api/types';

function render(priceType: ExtendedPriceTypeData) {
  const {
    price_type_desc: description,
    displayPrice,
  } = priceType;

  return `<div class="tn-syos-seat-info__price-type-description">
      ${description}
      ${renderFeeDisclaimer(priceType)}
  </div>
  <div class="tn-syos-seat-info__price-type-price">
      ${displayPrice}
  </div>`;
}

function renderFeeDisclaimer(priceType: ExtendedPriceTypeData) {
  if (!priceType.feeDisclaimer) {
    return '';
  }

  return `<div class="tn-syos-seat-info__price-type-fee-breakdown">${priceType.feeDisclaimer}</div>`;
}

export default render;
